import { getCrmTariffPaymentUrl } from '@crm/shared/config';

export const getCrmTariffUpgradeUrl = () => {
    const url = new URL(getCrmTariffPaymentUrl(), window.location.origin);
    url.searchParams.delete('changeManual');
    url.searchParams.delete('prolong');
    return url;
};
